$(function(){
	$('.faq-page').each(function () {

		$('.instruction__head').on('click', function () {
			$(this).next('.instruction__body').slideToggle(500);
			$(this).toggleClass('js-faq-active')
		});
		$('.js-dropdown-close').on('click', function () {
			$(this).closest('.instruction__body').slideToggle(500);
			$(this).closest('.instruction').find('.instruction__head').toggleClass('js-faq-active')
		});
	});
});
